import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '@wix/da-shared-react/pkg/Popup/ConfirmationModal';
import { Url } from '@wix/da-url';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';

const coreBallUrl = Url.staticCDNLink('video_generator/core_ball.png');

export interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

const UpgradeToCoreModal: FC<Props> = ({
  isOpen,
  onRequestClose,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const logBiEvent = useBiLogger();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      icon={
        <img
          src={coreBallUrl}
          alt={t('studio.videoCreator.results.emptyPlaceholder.altText')}
        />
      }
      title={t('studio.videoCreator.upgradeCoreModal.title')}
      text={t('studio.videoCreator.upgradeCoreModal.text')}
      confirmBtnLabel={t('studio.videoCreator.upgradeCoreModal.okButton')}
      cancelBtnLabel={t('studio.videoCreator.upgradeCoreModal.cancelButton')}
      confirmBtnType="core"
      onConfirm={() => {
        logBiEvent(
          BiData<BuyCoreButtonBiEvent>({
            evid: 375,
            referral_info: ReferralType.VIDEO_CREATOR_SAVE_DRAFT,
          })
        );
        const newTab = window.open(
          Url.coreMembershipLink({ referer: Url.videoCreatorLink() }),
          '_blank'
        );
        if (newTab) {
          newTab.focus();
        }
        onConfirm();
      }}
      onCancel={onCancel}
      onRequestClose={onRequestClose}
      withCancelButton
    />
  );
};

UpgradeToCoreModal.displayName = 'UpgradeToCoreModal';

export default UpgradeToCoreModal;
